<template>
    <chats-store
        v-slot="{
            promise: chatsStore
        }"
    >
        <messages-store
            v-slot="{
                sid,
                promise: messagesStore
            }"
        >
            <promise-chain
                v-slot="{
                    is_loading: is_saving,
                    has_loaded: has_saved,
                    execute: store,
                    error
                }"
                :callstack="{
                    chat: () => chatsStore(forms.chat),
                    message: ({ chat: { data: chat } }) => {
                        return messagesStore(_.extend({
                            chat: chat.uuid
                        }, forms.message))
                    }
                }"
                :execute-on-created="false"
                @success="onSuccess"
            >
                <base-form @submit="store">
                    <template v-if="tenants.length === 1">
                        <form-item
                            :sid="sid"
                            :is-required="true"
                            name="name"
                        >
                            <template slot="label">Name</template>

                            <input-text
                                :value="tenants[0].name"
                                :sid="sid"
                                :disabled="true"
                                name="name"
                            />
                        </form-item>
                    </template>

                    <template v-else>
                        <form-item
                            :sid="sid"
                            :is-required="true"
                            name="name"
                        >
                            <template slot="label">Profile</template>

                            <input-select
                                v-model="forms.persona.tenant"
                                :options="_.map(tenants, tenant => {
                                    return {
                                        label: tenant.name,
                                        value: {
                                            object: tenant.object,
                                            uuid: tenant.uuid
                                        }
                                    }
                                })"
                                :disabled="is_saving || has_saved"
                                name="persona"
                                placeholder="Select a profile..."
                            />
                        </form-item>
                    </template>

                    <form-item
                        :sid="sid"
                        :is-required="true"
                        name="text"
                    >
                        <template slot="label">Message</template>

                        <input-textarea
                            v-model="forms.message.text"
                            :sid="sid"
                            :disabled="is_saving || has_saved"
                            :rows="5"
                            name="text"
                            :placeholder="placeholder"
                        />
                    </form-item>

                    <base-button
                        :is-loading="is_saving || has_saved"
                        class="w-full btn-blue"
                    >
                        Send Message
                    </base-button>

                    <error-modal
                        v-if="error && $error.is(error, { exclude: [422] })"
                        :error="error"
                    />
                </base-form>
            </promise-chain>
        </messages-store>
    </chats-store>
</template>

<script>
    import _ from 'lodash'
    import axios from 'axios'
    import local from '../../../../store/local'
    import ChatsStore from '../../../../components/chats-store'
    import MessagesStore from '../../../../components/messages-store'
    import PromiseChain from '../../../../components/promise-chain'

    export default {
        components: {
            ChatsStore,
            MessagesStore,
            PromiseChain
        },
        props: {
            listing: {
                type: Object,
                required: true
            },
            tenants: {
                type: Array,
                required: true
            },
            placeholder: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                forms: {
                    persona: {
                        tenant: null
                    },
                    chat: {
                        personas: _.get(_.preload('message'), 'personas', [])
                    },
                    message: {
                        text: ''
                    }
                }
            }
        },
        watch: {
            'forms.persona.tenant' () {
                axios.defaults.headers.common['X-PERSONA-TOKEN'] = _.chain(this.tenants)
                    .find(this.forms.persona.tenant)
                    .get('persona_token')
                    .value()
            },
            'forms.message.text' () {
                local.set(`message-by-listing:${this.listing.uuid}`, this.forms.message.text)
            }
        },
        created () {
            this.forms.persona.tenant = _.pick(this.tenants[0], ['object', 'uuid'])

            if (!this.forms.message.text) {
                this.forms.message.text = local.get(`message-by-listing:${this.listing.uuid}`)
            }
        },
        methods: {
            onSuccess ({ chat: { data: chat } }) {
                window.location = this.$laroute.route('dashboard.tenants.chats.show', {
                    tenant: this.forms.persona.tenant.uuid,
                    message: chat.uuid
                })
            }
        }
    }
</script>
